import { Component, Input } from '@angular/core';
import { CardBadgeKind, IRecordCard } from '../../driver-background-check.view-models';

@Component({
  selector: 'app-bgc-section-criminal',
  templateUrl: './bgc-section-criminal.component.html',
  styleUrls: ['./bgc-section-criminal.component.scss', '../../driver-background-check.component.scss']
})
export class BgcSectionCriminalComponent {
  @Input() cards: IRecordCard[] = [];
  @Input() openByDefault: boolean;

  trackByCard(index: number, card: IRecordCard): string {
    return card.id;
  }

  badgeClass(kind: CardBadgeKind): string {
    return `badge-kind-${kind}`;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/components/bgc-section-criminal/bgc-section-criminal.component.ts